<mat-card appearance="outlined" class="!p-0 flex-1 flex flex-col">
    <div class="editor-form-wrapper">
        <ngx-monaco-editor class="monaco-editor-wrapper" [options]="editorOptions"
            [(ngModel)]="editorText" (onInit)="editorInit($event)"></ngx-monaco-editor>
    </div>
</mat-card>